import { 
  CONFIRMAR_SENHA, 
  CONFIRMAR_SENHA_VALIDAR, 
  ConfirmarSenhaActionTypes, 
  ConfirmarSenhaState 
} from "../../../types/confirmarSenha/confirmarSenha";

const INITIAL_STATE: ConfirmarSenhaState = {
    tokenValid: null,
    success: null,
}

export function ConfirmarSenhaReducer(
  state = INITIAL_STATE, 
  action: ConfirmarSenhaActionTypes
): ConfirmarSenhaState {
  switch (action.type) {
    case CONFIRMAR_SENHA:
      return { 
        ...state, 
        success: action.payload,
      };

      case CONFIRMAR_SENHA_VALIDAR:
        return { 
            ...state, 
            tokenValid: action.payload,
          };

    default:
      return state;
  }
}
